import "./StockTrackerComponent.scss";

interface StockTrackerComponentProps {

}

const StockTrackerComponent = (props: StockTrackerComponentProps) => {

    return (
        <div className={'StockTrackerComponent'}>
            <div>StockTrackerComponent</div>
        </div>
    );

};

export default StockTrackerComponent;